<template>
    <div>

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Proveedor"
                    :loading="loadingProvider"
                    :valueInput="values.provider_id"
                    :rule="rules.required"
                    :items="serverItems.providers"
                    :errorMessages="serverErrors.provider_id"
                    @valueChange="(v) => {values.provider_id = v; this.getPayables(v); delete serverErrors.provider_id}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Obra"
                    :loading="loadingPA"
                    :valueInput="values.contractor_payable_account_id"
                    :rule="rules.required"
                    :items="serverItems.PAs"
                    :errorMessages="serverErrors.contractor_payable_account_id"
                    @valueChange="(v) => {values.contractor_payable_account_id = v; delete serverErrors.contractor_payable_account_id}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>



       
        <v-row>
            <v-col class="py-2">
                <datePickerForm
                    label="Fecha de aplicación"
                    :valueInput="values.application_date"
                    :rule="rules.required"
                    @valueChange="(v) => {values.application_date = v; delete serverErrors['application_date']}"
                    :errorMessages="serverErrors['application_date']"
                ></datePickerForm>
            </v-col>
        </v-row>


       


        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.amount = v; delete serverErrors.amount}" 
                    :valueInput="values.amount" 
                    :rule="[...rules.amount, ...rules.required]" 
                    label="Monto"
                    :errorMessages="serverErrors.amount"
                    :prefix="values.amount == '' ? '': '$'"
                ></textFieldForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <fileInputForm
                    :accept="'.pdf,.PDF,.xlsx,.xlsm,.xlsb,.xltx,.xltm,.xls,.xlt,.xls,.xml,.xlam,.xla,.xlw,.xlr,.csv,.ods'"
                    label="Cotización"
                    :multiple="false"
                    :valueInput="values.quotation_file"
                    :url="values.quotation_file_url"
                    :rule="[]"
                    @valueChange="(v) => {values.quotation_file = v; delete serverErrors.quotation_file}"
                    :errorMessages="serverErrors.quotation_file"
                    v-on:update:url="values.quotation_file_url = $event"
                ></fileInputForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.comments = v; delete serverErrors.comments}" 
                    :valueInput="values.comments" 
                    :rule="[...rules.required]" 
                    label="Observaciones"
                    :errorMessages="serverErrors.comments"
                ></textFieldForm>
            </v-col>
        </v-row>

        
       
    </div>
</template>

<script>
/* eslint-disable */
export default {
    props: ['edit', 'values', 'serverErrors'],
    
   
    data(){
        return {
            loadingProvider: false,
            loadingPA: false,
            
            rules: {
				required: [
					v => !!v || 'El campo requerido',
                   
				],
                
                amount: [
                    v => {
                        if(v === null || v.toString().trim() === '')
                            return true;
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        
                        return true;
                    }
                ],
                number: [
                    v => {
                        // if(v === null || v.toString().trim() === '')
                        //     return true;
                        if(v!= null && !v.toString().match("^[0-9]{0,99999}$"))
                            return 'Solo números válidos';
                        
                        return true;
                    }
                ],
                items: [
                    v => {
                        if(v.length == 0)
                            return 'Al menos un producto o servicio';
                        return true;
                    }
                ]
               
				
				
            },
            serverItems: {
                providers: [],
                references: [],
            },

            

          
        }
    },
   
    mounted(){
        this.getProviders();
        if(this.edit){
            this.getPayables(this.values.provider_id);
        }
    },
    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        getProviders()
        {
            this.loadingProvider = true;
            this.$api.supplier.getSelectSuppliers(this.$store.state.business)
				.then((resp) =>{
					//console.log(resp, "desde form");
					this.serverItems.providers = resp.data;
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingProvider = false;
				})
			;
        },

        getPayables(supplier)
        {
            if(supplier == "" || supplier == undefined)
                return;
            // this.payableAccounts = [];
            this.loadingPA = true;
            this.$api.supplier.contractorPayableAccounts(this.$store.state.business, this.$route.params.construction, supplier)
                .then((resp) => {
                    // this.payableAccounts = resp.data;
                    this.serverItems.PAs = resp.data.map(item => {
                        return {value: item.value, text: item.text}
                    });
                    
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingPA = false;
                })
            ;
        },
       
    }
}
</script>

<style>

</style>